/**
 * Contractor (hauler) same-hauler write guards raise these exact messages
 * (fleet_management/services/hauler_guard.py). They are NOT `errorMsg401`, so
 * logoutLink ignores them — the Apollo error link surfaces them as a toast
 * instead of failing silently. Deliberately narrow (only these messages) so
 * it can't double-toast or alter any other error handling.
 *
 * Lives in its own module so a form that must NOT echo the toast a second
 * time can import the real list without pulling in the Apollo client setup
 * (and so its test asserts against the real list, not a copy).
 */
export const haulerGuardDeniedMessages = [
  'You do not have access to this record.',
  'Only office users can perform this action.',
]
